import { useState, useCallback } from 'react';

export type T206Mode = 'browse' | 'add' | 'edit';

export function useT206Mode() {
  const [mode, setMode] = useState<T206Mode>('browse');

  const isEditing = mode !== 'browse';

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return {
    mode,
    setMode,
    isEditing,
    enterAdd,
    enterEdit,
    enterBrowse,
  };
}
